// extracted by mini-css-extract-plugin
module.exports = {"cardList":"styles_cardList__34PlY"};